const SET_SINGLE_PANEL_STATE = 'setGoogleMapsLocationsPanelState';
const SET_LOCATION_INDEX = 'setLocationIndex';
const SET_OLD_LOCATIONS_FOR_SESSION = 'setOldLocationsForSession';

export {
  SET_SINGLE_PANEL_STATE,
  SET_LOCATION_INDEX,
  SET_OLD_LOCATIONS_FOR_SESSION,
};
